import ApiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";

export default {
  namespaced: true,
  state: {
    isVeg: false,
    configuredCategoryData:[],
    isLoadingConfiguredCategoryAPI: false,
    configuredCategoryApiLoadTime: 0,
    configuredCategoryApiFailData: null,
    categoryMenuGridType: '',
  },
  getters: {},
  mutations: {
    setIsLoadingConfiguredCategoryAPI(state, payload) {
      state.isLoadingConfiguredCategoryAPI = payload;
    },
    updateConfiguredCategoryData(state,payload){
      state.configuredCategoryData = payload?.response;
    },
    updateConfiguredCategoryApiLoadTime(state,payload){
      state.configuredCategoryApiLoadTime = payload;
    },
    updateConfiguredCategoryApiFailData(state,payload){
      state.configuredCategoryApiFailData = payload;
    },
    updateCategoryGridType(state,payload){
      state.categoryMenuGridType = payload;
    },
  },
  actions: {
    getConfiguredCategoryData({ commit }, payload) {
      commit("setIsLoadingConfiguredCategoryAPI", true);
      const startTime = new Date();
      ApiCalls
        .GET_CONFIGURED_CATEGORY_API({
          headers: Headers(),
          payload: {
            "api" : payload?.api,
            "apiPayload" : {
              "store_id" : LocalStorageFunc.storeId(),
              'tenant' : payload?.tenant,
              'menu_type' : payload?.menuType,
            },
          }
        })
        .then(function (response) {
          const endTime = new Date();
          commit("updateConfiguredCategoryApiLoadTime", endTime - startTime);
          let data1 = response?.data?.data || [{}];
          const {data = [] , meta = {}} = data1[0];
          commit("updateConfiguredCategoryData", {
            "response" : data
          });
          commit("updateCategoryGridType" , meta?.menuType);
        })
        .catch(function (e) {
          const endTime = new Date();
          let errMsg = e?.message;

          if(e?.response?.data){
            errMsg = e?.response?.data;
          }
          commit("updateConfiguredCategoryApiLoadTime", endTime - startTime);
          commit("updateConfiguredCategoryApiFailData", errMsg || e?.message);
        })
        .finally(function() {
          commit("setIsLoadingConfiguredCategoryAPI", false);
        })
    },
  },
};
